import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as GenderActions from './gender.actions';
import { GenderService } from '../../services/gender.service';

@Injectable()
export class GenderEffects {
  loadGender$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenderActions.loadGender),
      exhaustMap((_) =>
        this.genderService.getGender().pipe(
          map((data) => GenderActions.loadGenderSuccess({ gender: data })),
          catchError((error) => of(GenderActions.loadGenderFailure({ error })))
        )
      )
    )
  );

  addGender$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenderActions.addGender),
      concatMap(({ newGender }) =>
        this.genderService.createGender(newGender).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return GenderActions.addGenderSuccess({
              newGender: data,
            });
          }),
          catchError((error) =>
            of(GenderActions.addGenderFailure({ error: error.error.message }))
          )
        )
      )
    )
  );

  updateGender$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenderActions.updateGender),
      map((action) => action.updateGender),
      concatMap((updateGender) =>
        this.genderService.updateGender(updateGender).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return GenderActions.updateGenderSuccess({
              updateGender: updateGender,
            });
          }),
          catchError((error) =>
            of(GenderActions.updateGenderFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeGender$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GenderActions.removeGender),
      map((action) => action.ids),
      concatMap((ids) =>
        this.genderService.deleteGender(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return GenderActions.removeGenderSuccess({ ids });
          }),
          catchError((error) =>
            of(GenderActions.updateGenderFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private genderService: GenderService,
    private notification: NotificationService
  ) {}
}
